import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { Dialog, DialogContent, DialogTitle } from 'base-ui'

import { type OpenableControls } from '../../../../../generic-hooks'

import { ProductPagePrescriptionTypeSelectionModalDesktopContent } from './DynamicProductPagePrescriptionTypeSelectionModalDesktopContent.tsx'

type ErxTypeSelectModalProps = {
  controls: Pick<OpenableControls, 'handleClose' | 'isOpen'>
}

export const ProductPagePrescriptionTypeSelectionModalDesktop: FC<
  ErxTypeSelectModalProps
> = ({ controls }) => {
  return (
    <Dialog
      data-qa-id="rxSelectModal"
      onClose={controls.handleClose}
      open={controls.isOpen}
    >
      <DialogTitle onClose={controls.handleClose}>
        <FormattedMessage id="rxSelectModal.title.variantA" />
      </DialogTitle>
      <DialogContent className="bg-light-primary-medium p-12">
        <ProductPagePrescriptionTypeSelectionModalDesktopContent />
      </DialogContent>
    </Dialog>
  )
}
